module.exports = __webpack_public_path__ + "img/icon_remove.c637aa72.png";